import { createAction } from '@reduxjs/toolkit'
import type { ResetEventAction } from '../types'

export const resetAction = createAction<ResetEventAction | undefined>('OP_RESET')
